export default {"src":"/_next/static/media/sugar-cubes-multicoloured.197a3126.svg","height":63,"width":60,"blurWidth":0,"blurHeight":0};